import { createFileRoute } from '@tanstack/react-router'

import SearchProductsPage from '@/layouts/themes/phong-nha/pages/search'

export const Route = createFileRoute('/phong-nha/search')({
  component: SearchProductsPage,
})
